/**
 * Initialize a simple version of the accordion for use inside Instant Search JS.
 */
export default function accordionSimple() {
  const accordionSimple = document.querySelector( '.js-accordion--simple' )

  if ( !accordionSimple ) {
    return
  }

  const accordionItems = accordionSimple.querySelectorAll( '.js-accordion--simple-item' )

  Array.from( accordionItems )
    .forEach( accordionItem => {
      const accordionItemContainer = accordionItem.querySelector( '.ac' )
      const accordionItemQuestion = accordionItem.querySelector( '.ac-q' )

      if ( !accordionItem.classList.contains( 'loaded' ) ) {
        accordionItemQuestion.addEventListener( 'click', () => {
          toggleAccordion( accordionItem, accordionItemContainer, accordionItemQuestion )
        })

        accordionItemQuestion.addEventListener( 'focus', () => {
          accordionItemContainer.classList.add( 'border-blue-60' )
          accordionItemContainer.classList.remove( 'border-black-20' )
        })

        accordionItemQuestion.addEventListener( 'blur', () => {
          accordionItemContainer.classList.remove( 'border-blue-60' )
          accordionItemContainer.classList.add( 'border-black-20' )
        })
      }

      accordionItem.classList.add( 'loaded' )
    })

  /**
   * Toggle an accordion row. Sets focus colors, animation height and aria labels.
   *
   * @param {element} accordion Current accordion row.
   * @param {element} accordionItemContainer Current accordion row container.
   * @param {element} accordionItemQuestion The button to toggle the accordion.
   */
  function toggleAccordion( accordion, accordionItemContainer, accordionItemQuestion ) {
    const accordionItemAnswer = accordion.querySelector( '.ac-a' )
    const answerContent = accordionItemAnswer.querySelector( '.js-accordion-item-answer-section' )

    if ( accordion.classList.contains( 'opened' ) ) {
      accordion.classList.remove( 'opened' )
      accordionItemQuestion.setAttribute( 'aria-expanded', false )
      accordionItemContainer.classList.remove( 'border-blue-60' )
      accordionItemAnswer.style.height = '0px'
    } else {
      closeAllAccordions()
      accordion.classList.add( 'opened' )
      accordionItemContainer.classList.add( 'border-blue-60' )
      accordionItemQuestion.setAttribute( 'aria-expanded', true )
      accordionItemAnswer.style.height = `${answerContent.offsetHeight}px`
    }
  }

  /**
   * Close all accordions.
   */
  function closeAllAccordions() {
    Array.from( accordionItems )
      .forEach( accordionItem => {
        accordionItem.querySelector( '.ac-a' ).style.height = '0px'
      })
  }
}
